import React, { useEffect } from 'react'
import Loading from '../../components/Loading'
import { connect } from 'react-redux'
import { setTitle, getAll } from '../../actions'
import Table from '../../components/Table'

const Subscriptions = props => {
  const { subscriptions, setTitle } = props

  useEffect(() => {
    setTitle({ title: 'Suscripciones' })
    props.getAll('subscriptions', 'GET_SUBSCRIPTIONS')
    // eslint-disable-next-line
  }, [])

  if (!subscriptions) return <Loading />

  const columns = [
    { header: 'ID', accessorKey: 'id' },
    { header: 'Correo', accessorKey: 'email' },
    { header: 'Origen', accessorKey: 'source' },
    { header: 'Creado', accessorKey: 'created' },
  ]

  return (
    <Table
      data={subscriptions}
      columns={columns}
      name='Suscripciones'
      showColumnFilters={false}
      path='subscriptions'
      actionAfterDelete='GET_SUBSCRIPTIONS'
      nameFile='Suscripciones'
      exportButton
    />
  )
}

const mapStateToProps = state => ({
  subscriptions: state.subscriptions.subscriptions,
})

const mapDispatchToProps = {
  setTitle,
  getAll,
}

export default connect(mapStateToProps, mapDispatchToProps)(Subscriptions)
